export default import.meta.ROLLDOWN_FILE_URL_NMVLWf4DMBUp84Fp5hzlPw